<template>
  <div>
    <Toolbar :handle-submit="onSendForm" :handle-reset="resetForm">
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-checkerboard</v-icon>{{$t('profile.printingsurface.materials')}}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>
    <PrintingSurfaceMaterialForm ref="createForm" :values="item" :errors="violations" />
    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { createHelpers } from 'vuex-map-fields';
import PrintingSurfaceMaterialForm from '../../components/printingsurfacematerial/Form';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import CreateMixin from '../../mixins/CreateMixin';

const servicePrefix = 'PrintingSurfaceMaterial';

const { mapFields } = createHelpers({
  getterType: 'printingsurfacematerial/getField',
  mutationType: 'printingsurfacematerial/updateField'
});

export default {
  name: 'PrintingSurfaceMaterialCreate',
  servicePrefix,
  mixins: [CreateMixin],
  components: {
    Loading,
    Toolbar,
    PrintingSurfaceMaterialForm
  },
  data() {
    return {
      item: {}
    };
  },
  computed: {
    ...mapFields(['error', 'isLoading', 'created', 'violations'])
  },
  methods: {
    ...mapActions('printingsurfacematerial', ['create', 'reset'])
  }
};
</script>
